export const getLatLng = (latitude: unknown, longitude: unknown): { lat: number, lng: number } | undefined => {
    const isCoordinate = (value: unknown): value is number | string =>
        typeof value === 'number' || (typeof value === 'string' && value.trim() !== '');

    if (!isCoordinate(latitude) || !isCoordinate(longitude)) return undefined;

    const lat = Number(latitude);
    const lng = Number(longitude);

    return Number.isFinite(lat) && Number.isFinite(lng) ? { lat, lng } : undefined;
};
